import React from 'react';
import Card from 'react-bootstrap/Card';

import Header from './header';
import Pane from './pane';
import withNameInput from './hoc-input';

const DpManagementFee = withNameInput('dpManagementFee', 'Management Fee', true);
const DpPerformanceFee = withNameInput('dpPerformanceFee', 'Actual Performance Fee', true);
const DpPerformanceFeePds = withNameInput('dpPerformanceFeePds', 'Performance Fee', true);
const DpTotalCostRatio = withNameInput('dpTotalCostRatio', 'Total Cost Ratio', true);
const DpFinancialYearEndFeesDate = withNameInput('dpFinancialYearEndFeesDate', 'Financial Year End Fees Date', true);
const DpBuySpread = withNameInput('dpBuySpread', 'Buy Spread', true);
const DpSellSpread = withNameInput('dpSellSpread', 'Sell Spread', true);
const DpPDSFeesDate = withNameInput('dpPdsFeesDate', 'PDS Fees Date', true);
const DpLatestProspectusDate = withNameInput('dpLatestProspectusDate', 'Prospectus Date', true);
const DpDayEndEntryPrice = withNameInput('dpDayEndEntryPrice', 'Day End Entry Price', true);
const DpDayEndExitPrice = withNameInput('dpDayEndExitPrice', 'Day End Exit Price', true);
const DpDayEndNavPrice = withNameInput('dpDayEndNavPrice', 'Day End NAV Price', true);
const DpDayEndPricingUpdateDate = withNameInput('dpDayEndPricingUpdateDate', 'Day End Pricing Update Date', true);
const DpDayEndMarketPrice = withNameInput('dpDayEndMarketPrice', 'Day End Market Price', true);
const DpDayEndMarketPriceDate = withNameInput('dpDayEndMarketPriceDate', 'Day End Market Price Date', true);
const DpDayEndNav = withNameInput('dpDayEndNav', 'Day End Nav', true);
const DpDayEndNavDate = withNameInput('dpDayEndNavDate', 'Day End NAV Date', true);

export default function DpFundFees() {
  const event = 'dpFees';

  return (
    <Card>
      <Card.Header>
        <Header eventKey={event}>Fund Fees from Data Provider</Header>
      </Card.Header>
      <Pane eventKey={event}>
        <Card.Body>
          <DpManagementFee />
          <DpPerformanceFeePds />
          <DpPerformanceFee />
          <DpTotalCostRatio />
          <DpFinancialYearEndFeesDate />
          <DpBuySpread />
          <DpSellSpread />
          <DpPDSFeesDate />
          <DpLatestProspectusDate />
          <DpDayEndEntryPrice />
          <DpDayEndExitPrice />
          <DpDayEndNavPrice />
          <DpDayEndPricingUpdateDate />
          <DpDayEndMarketPrice />
          <DpDayEndMarketPriceDate />
          <DpDayEndNav />
          <DpDayEndNavDate />
        </Card.Body>
      </Pane>
    </Card>
  );
}
